import React from 'react';
import { X } from 'lucide-react';

interface PreferenceCenterModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

export function PreferenceCenterModal({ isOpen, onClose, url }: PreferenceCenterModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-0">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative w-full max-w-5xl mx-2 bg-white dark:bg-gray-800 rounded-lg shadow-xl">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute -top-2 -right-2 bg-[#5e9bb8] text-white p-1 rounded-full hover:bg-[#4d8299] transition-colors duration-200 z-10"
          >
            <X className="h-5 w-5" />
          </button>

          {/* Modal content */}
          <div className="w-full h-[700px] rounded-lg overflow-hidden">
            <iframe
              src={url}
              title="OneTrust"
              className="w-full h-full"
              frameBorder="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}